var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavbell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.17313,
    y: 0.959996,
    width: 30.0799,
    height: 30.0799,
    rx: 15.0399,
    fill: "#EFF3FB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.17313,
    y: 0.959996,
    width: 30.0799,
    height: 30.0799,
    rx: 15.0399,
    stroke: "#D7E1F4",
    strokeWidth: 1.91999
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2931 21.5233C14.8026 21.9092 15.4755 22.1439 16.2131 22.1439C16.9507 22.1439 17.6236 21.9092 18.1331 21.5233M10.8186 19.5373C10.515 19.5373 10.3455 19.0852 10.5291 18.834C10.9552 18.251 11.3665 17.3961 11.3665 16.3665L11.384 14.8747C11.384 12.1029 13.5461 9.85596 16.2131 9.85596C18.9194 9.85596 21.1133 12.136 21.1133 14.9486L21.0957 16.3665C21.0957 17.4031 21.4928 18.2628 21.9015 18.8459C22.078 19.0978 21.9081 19.5373 21.6083 19.5373H10.8186Z",
    stroke: "#4169E1",
    strokeWidth: 1.27999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbell);
export default __webpack_public_path__ + "static/media/navbell.ef643569f0eae562ef64972082e8b7ed.svg";
export { ForwardRef as ReactComponent };